module.exports = __webpack_public_path__ + "static/media/illustration.e13303b3.svg";